import { useState, useEffect } from 'react'
import Modal from './Modal'
import { useI18n } from '../i18n'

/**
 * Универсальный модал ввода кода 2FA для подключения к провайдеру (OnlyFans API и т.д.).
 * @param {string} title - Заголовок модала
 * @param {string} titleId - id для заголовка (a11y)
 * @param {string} formId - id формы (должен быть уникальным на странице)
 * @param {boolean} open
 * @param {object} [model] - модель для отображения в описании
 * @param {function} onConnect - (twoFa: string | null) => void
 * @param {function} onCancel
 */
export default function TwoFAModal({ title, titleId, formId, open, model, onConnect, onCancel, showOnlyFansApiAccountFields = false }) {
  const { t } = useI18n()
  const [twoFa, setTwoFa] = useState('')
  const [apiKey, setApiKey] = useState('')
  const [accountId, setAccountId] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    setTwoFa('')
    setApiKey('')
    setAccountId('')
    setError('')
  }, [open])

  function handleSubmit(e) {
    e.preventDefault()
    setError('')
    if (showOnlyFansApiAccountFields) {
      onConnect({
        twoFa: twoFa.trim() || null,
        apiKey: apiKey.trim(),
        accountId: accountId.trim(),
      })
      return
    }
    onConnect(twoFa.trim() || null)
  }

  const modelName = model?.of_email || model?.name || t('common.notAvailable')
  const description = model
    ? t('models.twoFa.descriptionWithModel', { model: modelName })
    : t('models.twoFa.description')

  return (
    <Modal
      open={open}
      title={title}
      titleId={titleId}
      onClose={onCancel}
      footer={
        <div className="modal-actions modal-actions--center">
          <button type="submit" form={formId} className="modal-btn modal-btn-primary">
            {t('models.twoFa.connect')}
          </button>
        </div>
      }
    >
      <p className="modal-desc">{description}</p>
      <form id={formId} onSubmit={handleSubmit} className="modal-form">
        {error && <div className="modal-error">{error}</div>}
        <label>
          {t('models.twoFa.label')}
          <input
            type="text"
            value={twoFa}
            onChange={(e) => setTwoFa(e.target.value)}
            placeholder={t('models.twoFa.placeholder')}
            autoComplete="one-time-code"
            autoFocus
          />
        </label>
        {showOnlyFansApiAccountFields && (
          <>
            <label>
              API key
              <input
                type="password"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="Optional if global key is configured"
                autoComplete="off"
              />
            </label>
            <label>
              Account ID
              <input
                type="text"
                value={accountId}
                onChange={(e) => setAccountId(e.target.value)}
                placeholder="Optional: auto-detect from model"
                autoComplete="off"
              />
            </label>
          </>
        )}
      </form>
    </Modal>
  )
}
